{
  "Clear search": "Borrar búsqueda"
}
